import React from "react";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore"
import Grid from "@material-ui/core/Grid"
import Button from '@material-ui/core/Button';

const SignIn = () => {
    const auth = firebase.auth();
    const signInWithGoogle = () => {
        const provider = new firebase.auth.GoogleAuthProvider();
        auth.signInWithPopup(provider);
    }
    return(
        <Grid container justifyContent="center" style={{marginTop: "10vh"}}>
            <Button onClick={signInWithGoogle} variant="outlined">Sign In With Google</Button>
        </Grid>
    );
}

// const SignOut = () => {
//     return auth.currentUser && (
//         <Button onClick={() => auth.singOut()}>Sign Out</Button>
//     )
// }

export { SignIn };